import React, { useState, useEffect } from 'react';
import { FaArrowUp } from 'react-icons/fa';

const BackToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const toggleVisible = () => {
      setVisible(window.scrollY > 300);
    };
    
    window.addEventListener('scroll', toggleVisible);
    return () => window.removeEventListener('scroll', toggleVisible);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ 
      top: 0, 
      behavior: 'smooth' 
    });
  };

  return (
    <>
      {visible && (
        <button
          onClick={scrollToTop}
          className="btn btn-success rounded-circle shadow-lg position-fixed d-flex align-items-center justify-content-center"
          style={{
            bottom: '200px',  // ✅ Perfect position
            right: '20px',
            width: '55px',
            height: '55px',
            zIndex: 999,
            border: 'none',
            background: 'linear-gradient(135deg, #00D084 0%, #00A86B 100%)',
            transition: 'all 0.3s ease',
            animation: 'fadeIn 0.3s ease'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-5px) scale(1.05)';
            e.currentTarget.style.boxShadow = '0 15px 30px rgba(0, 208, 132, 0.4)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0) scale(1)';
            e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.2)';
          }}
          aria-label="Back to Top"
          title="Back to Top"
        >
          <FaArrowUp style={{ fontSize: '1.2rem' }} />
        </button>
      )}

      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </>
  );
};

export default BackToTop;
